/*** Imports ***/

/* Library imports */
import React from "react";
import PropTypes from 'prop-types';

/* Style imports */
import './styles.css';
/*** End Imports ***/

const SubSection = (props) => {

    // helper function
    // event handlers for static component
    let CustomStyle;
    if(props.type2) {
        CustomStyle = {font: 'normal 16px/20px GillSans Regular'}
    }

    return (
        <div className="sub-section-content">
            <p style={CustomStyle}>{props.children}</p>
        </div>
    );
};

/**
 * all prop types which can be passed to this component
 */
SubSection.propTypes = {
    CustomStyle: PropTypes.object,
};

/**
 * Only if default initialization is required
 * Default props value for this component
 */
SubSection.defaultProps ={

};

export default SubSection;


// WEBPACK FOOTER //
// ./src/components/GetMoreProfilesModal/Components/GetDataBaseView/Component/SubSection/SubSection.js